import React from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { SentAlertsWidgetProps } from "../../js/headersegment/interfaces";

const SentAlertsWidget: React.FC<SentAlertsWidgetProps> = ({ widgetFiredAlerts }) => {

    return (<>
        <div className="widget">
            <div className="header">
                SENT ALERTS
                <OverlayTrigger delay={{ hide: 450, show: 300 }} placement="top"
                    overlay={(props) => (
                        <Tooltip {...props} className="overlay-tooltip">
                            Messages automatically sent to agents or passengers based on Cirium Trip monitoring.
                        </Tooltip>
                )}>
                    <div className="popover-icon sprites sprite-details-selected-16 m-0 margin-left-5"></div>
                </OverlayTrigger>
            </div>

            <div className="data-header">
                <table className="table table-condensed">
                    <thead>
                        <tr>
                            <th className="left datetime-width">TIME</th>
                            <th className="left issue-type">EVENT</th>
                            <th className="left issue-type">FLIGHT</th>
                        </tr>
                    </thead>
                </table>
            </div>

            <div className="data">
                <table className="table table-condensed">
                    {widgetFiredAlerts && widgetFiredAlerts.length > 0 ? (
                        <tbody>
                            {widgetFiredAlerts.map((alert, index) => (
                                <tr key={index}>
                                    <td>{alert.sentAt}</td>
                                    <td>
                                        {alert.tripNotificationUrl ? (
                                            <a href={alert.tripNotificationUrl}>{alert.alertType}</a>
                                            ) : (
                                            alert.alertType
                                        )}
                                    </td>
                                    <td>
                                        <span style={{ display: 'inline-block' }}>{alert.flight}</span>
                                        <span style={{ display: 'inline-block' }}>{alert.flightPath}</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            <tr>
                                <td className="none-found" colSpan={3}>
                                No messages.
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    </>);
}

export default SentAlertsWidget;